import React from "react";
import packageJson from "../../../package.json";
import dayjs from "dayjs";
function Index() {
  const date = dayjs().year();
  return (
    <div className="bg-headerBack w-full hidden md:block h-10">
      <div className="container mx-auto py-3 px-5 flex items-center justify-center">
        <span className="text-white text-sm text-center">
          Developed by &copy; MrMuscle {date}
        </span>
        {/* <span className="text-white ml-2">{process.env.NODE_ENV}</span> */}
        <span className="text-white ml-2">version: {packageJson.version}</span>
      </div>
    </div>
  );
}

export default Index;
